import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {required} from '@app/shared/validators'

@Component({
    selector: 'lta-restore-access-screen',
    templateUrl: 'restore-access-screen.component.html',
    styleUrls: ['restore-access-screen.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RestoreAccessScreenComponent implements OnInit {
    public restoreForm: FormGroup;

    constructor(private formBuilder: FormBuilder) {
    }

    ngOnInit(): void {
        this.restoreForm = this.formBuilder.group({
            newPassword: new FormControl('', [required]),
            repeatPassword: new FormControl('', [required]),
        });
    }

    submitForm() {
        console.log(this.restoreForm.value);
    }
}
